import {
    beforeCheckout, checkCompanyUid, checkCustomQuestion,
    checkField, checkNumeric,
    checkPaymentEmail, checkPaymentName, checkPaymentPhone,
    checkReceiverAddress,
    checkReceiverIntAddress,
    checkStocks, validatorResult
} from "@plugins-fr/payment";
import {ProductCustomFieldDataContainerHelper} from "@plugins-fr/CustomFields";
import {recordUserEventTrack} from "@commons/userTracks/userTrack";
import {checkoutPageSubmit} from "@commons/userTracks/eventActionName";

$(function() {
    validatorResult();

    // 外部區塊命名規則為 id=欄位名_area
    $('#order_form').on('change', '#order_fileds input, #order_fileds select', function() {
        var id = $(this).attr('id');
        switch (id){
            case 'purchaser_email' :
            case 'receiver_email':
                checkPaymentEmail(false, id);
                break;

            case 'purchaser_phone' :
            case 'receiver_phone' :
                checkPaymentPhone(id);
                break;

            case 'purchaser_name' :
            case 'receiver_name':
                checkPaymentName(id);
                break;

            case 'lovecode' :
                checkField('#lovecode_area', '#lovecode', '');
                checkNumeric('#lovecode_area', '#lovecode');
                break;

            case 'company_uid' :
                checkCompanyUid();
                break;

            case 'receiver_address':
                checkReceiverAddress();
                break;

            case 'int_receiver_address':
            case 'int_receiver_district':
            case 'int_receiver_zip':
                checkReceiverIntAddress(true);
                break;

            case 'int_receiver_country':
                checkField('#receiver_int_country_area', '#int_receiver_country', 'none');
                break;

            case 'receiver_country_select':
                checkField('#receiver_address_country_area', '#receiver_country_select', '');
                break;

            case 'receiver_address_zip':
                checkReceiverAddressZip();
                break;

            case undefined :
                if ($(this).hasClass('js_receiver_city')) {
                    checkField('#receiver_city_area', '.js_receiver_city', '');
                }

                if ($(this).hasClass('js_shops_custom_question')) {
                    // 清除值是個空白，預防 placeholder 顯示不出來
                    if ($.trim($(this).val()) === '') {
                        $(this).val('');
                    }
                    checkCustomQuestion($(this).closest('.js_shops_custom_question_area'));
                }
                break;
            default :
                if (id == 'shipping') {
                    checkPaymentEmail(true);
                    break;
                }

                if (id == 'payment') {
                    checkPaymentEmail(true);
                }
                if ($(this)[0].tagName == 'SELECT') {
                    checkField('#' + id + '_area', '#' + id, 'none');
                } else {
                    checkField('#' + id + '_area', '#' + id, '');
                }
        }
    });

    // 送出前檢查
    $('#order_submit').click(function(){
        if (beforeCheckout($(this))) {
            checkStocks(false, $(this), function(){
                if (isReservable) {
                    ProductCustomFieldDataContainerHelper.insertAnswers();
                }

                recordUserEventTrack(checkoutPageSubmit, $('#order_form').attr('action'));
                $('#order_form').trigger('submit');
            });
        }
    });

});

$(window).on('load', function(){
    // 剛進結帳頁，有可能觸發其他 cartItemsActionAjax，導致庫存檢查回傳渲染好購物車畫面後，畫面又被覆蓋，
    // 但結帳頁 js 不好調整，所以暫時解法是先延遲 1 秒
    setTimeout(() => {
        checkStocks(true, $('#order_submit'));
    }, 1000);
});
